import { useCleanPostData } from '@features/post/contexts/CleanPostDataContext'
import { publicUrl } from '@libs/appUrl'
import { trackArticleReadMorePopularListEnterArticleEvent } from '@libs/eventTracking/article/article.read-more-popular-list.enter-article'
import { PageComponents } from '@libs/eventTracking/article/common'
import { appendUrlSearchParams } from '@libs/url-utils'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import tw, { theme } from 'twin.macro'
import DesktopPopularArticleCard from './DesktopPopularArticleCard'
import MobilePopularArticleCard from './MobilePopularArticleCard'

export default function PopularArticles(props) {
  const { articles, isApp } = props
  const { t } = useTranslation('post')
  const { post } = useCleanPostData()

  if (articles.length == 0 || !Array.isArray(articles)) return null

  return (
    <OuterWrapper className="popular-articles">
      <Title>{t(['popularArticles', '熱門排行榜'])}</Title>
      <Container>
        {articles.map((article) => {
          const { url, publisher, coverImage, title, plainTextContent, postID, categories } =
            article

          const displayedPlainTextContent = plainTextContent.substr(0, 60)
          const articleImage = {
            url: coverImage?.croppedUrl || publicUrl('/images/articleCardImagePlaceholder.svg'),
            noShaper: !coverImage?.croppedUrl,
          }

          const trackEnterEvent = () => {
            trackArticleReadMorePopularListEnterArticleEvent({
              article: post,
              toPageUrl: url,
              actionTarget: postID,
            })
          }

          const completedUrl = appendUrlSearchParams(url, {
            fromPage: {
              pageName: 'article',
              pageComponent: PageComponents.READ_MORE_POPULAR_LIST,
            },
          })

          const cardProps = {
            completedUrl,
            title,
            displayedPlainTextContent,
            isApp,
            publisher,
            articleImage,
            trackEnterEvent,
            categories,
          }

          return (
            <Fragment key={article.id}>
              <DesktopPopularArticleCard {...cardProps} />
              <MobilePopularArticleCard {...cardProps} />
            </Fragment>
          )
        })}
      </Container>
    </OuterWrapper>
  )
}

const OuterWrapper = styled.div`
  ${tw`pt-5`}
  @media (min-width: ${theme`screens.md`}) {
    ${tw`pt-0`}
    background-color: white;
  }
`

const Title = styled.p`
  ${tw`relative text-h4 font-semibold text-center text-black`}
  height: 28px;
  letter-spacing: 0.5px;
  &:after {
    content: '';
    width: 40px;
    height: 2px;
    bottom: -12px;
    left: 0;
    right: 0;
    margin: auto;
    ${tw`absolute bg-black`}
  }
  @media (min-width: ${theme`screens.md`}) {
    margin-top: 20px;
  }
`

const Container = styled.div`
  margin-top: 32px;
  @media (min-width: ${theme`screens.md`}) {
    margin-top: 40px;
  }
`
